var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"page-spacing"},[_c('v-col',{staticClass:"d-flex align-center pb-0",attrs:{"cols":"12"}},[_c('v-spacer'),_c('rehber-video-button',{attrs:{"area":"dilekceler","label":"DİLEKÇE REHBER VİDEO","small":""}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c('dilekce-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }